import axios from "axios";

const serverUrl = "https://server-v6.xmreality.com";

const authority = "https://teams-integration.prod.xmreality.net";
const tokenUrl = `${authority}/api/office/token`;

const xmInstance = axios.create({
  baseURL: `${serverUrl}/api/v12`,
  headers: {
    "XM-Client-Version": 1,
    // TODO: Fix me
    "XM-Client-Platform": "teams-frontend",
  },
});

export function setUdid(udid) {
  xmInstance.defaults.headers["XM-Device-UDID"] = udid;
}

export function setAuthToken(token) {
  xmInstance.defaults.headers["Auth-Token"] = token;
}

export function getMeeting(meetingId) {
  return xmInstance({
    method: "GET",
    url: `/meetings/${meetingId}`,
  }).then((response) => response.data);
}

export function createMeeting(title, scheduledAt) {
  return xmInstance({
    method: "POST",
    url: "/meetings",
    data: {
      title,
      description: "See details in Outlook invitation",
      scheduledAt,
      settings: {
        requireName: true,
        requirePassword: false,
      },
    },
  }).then((response) => response.data);
}

export function deleteMeeting(meetingId) {
  return xmInstance({
    method: "DELETE",
    url: `/meetings/${meetingId}`,
  }).then((response) => response.data);
}

export function authenticate() {
  return xmInstance({
    method: "POST",
    url: "/authentication/refresh",
  }).then((response) => response.data);
}

export function unauthenticate() {
  return xmInstance({
    method: "POST",
    url: "/authentication/unauthenticate",
  }).then((response) => response.data);
}

export function postToken(authenticationToken, token) {
  return axios
    .post(
      tokenUrl,
      {
        token,
      },
      {
        headers: {
          Authorization: `Bearer ${authenticationToken}`,
        },
      }
    )
    .then((response) => response.data);
}

export function getToken(authenticationToken) {
  return axios
    .get(tokenUrl, {
      headers: {
        Authorization: `Bearer ${authenticationToken}`,
      },
    })
    .then((response) => response.data)
    .catch (e => {
      if (e?.response.status === 404) {
        return null;
      }
      return Promise.reject(e);
    })
}

export function deleteToken(authenticationToken) {
  return axios
    .delete(tokenUrl, {
      headers: {
        Authorization: `Bearer ${authenticationToken}`,
      },
    })
    .then((response) => response.data);
}
